import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QuoteProvider } from "@/context/QuoteContext";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Reviews from "@/pages/Reviews";
import LeadsDashboard from "@/pages/LeadsDashboard";

function App() {
  return (
    <BrowserRouter>
      <QuoteProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/leads" element={<LeadsDashboard />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </QuoteProvider>
    </BrowserRouter>
  );
}

export default App;
